import { Button, Loading } from '@orobix/orobix-fe-components'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router-dom'

import { locations } from '../../../utils/locations'
import { TrainingUuid } from '../SearchButton/utils'

const loadingIcon = <Loading />

type OpenTrainingButtonProps = {
  isDisabled: boolean
  isLoading: boolean
  trainingUuid?: TrainingUuid
}

const OpenTrainingButton = ({
  isDisabled,
  isLoading,
  trainingUuid,
}: OpenTrainingButtonProps) => {
  const { t } = useTranslation()
  const [isFetching, setFetching] = useState(false)
  const history = useHistory()

  function getTrainingLink() {
    if (trainingUuid) {
      return locations.training(
        Number(trainingUuid.project.id),
        Number(trainingUuid.product.id),
        Number(trainingUuid.id)
      )
    }
    return ''
  }

  const handleClick = async () => {
    setFetching(true)
    if (trainingUuid) {
      history.push(getTrainingLink())
    }
    setFetching(false)
  }

  return (
    <Button
      label={t('View training "{{ name }}"', {
        name: `${String(trainingUuid ? trainingUuid.product.name : '')}`,
      })}
      title={getTrainingLink()}
      type="action"
      disabled={isDisabled || isFetching}
      onClick={(e) => {
        e.preventDefault()
        handleClick()
      }}
      icon={isLoading || isFetching ? loadingIcon : null}
    />
  )
}

export default OpenTrainingButton
